import resolveConfig from "tailwindcss/resolveConfig";
import tailwindConfig from "tailwind.config.js";
export const screenIs = (screen = "") => {
  const config = resolveConfig(tailwindConfig);
  const screens = config.theme.screens;
  const matches = Object.entries(screens).reduce((results, [name, size]) => {
    const mediaQuery =
      typeof size === "string"
        ? `(min-width: ${size})`
        : `(max-width: ${size.max})`;
    results[name] = window.matchMedia(mediaQuery).matches;
    return results;
  }, {});
  if (screen === "") {
    return matches;
  }
  if (!screens[screen]) {
    console.error(`No match for "${screen}"`);
    return false;
  }
  return matches[screen];
};

export function discount(oldValue, newValue) {
  if (!oldValue) return 0;

  const d = oldValue - newValue;
  return Math.abs(Math.round((d * 100) / oldValue));
}
